// extracted by mini-css-extract-plugin
export default {"contacts__container":"ContactsPage_contacts__container__3DzLL"};